/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '../../button/button.component';

@Component({
  selector: 'ods-dialog-header',
  imports: [ButtonComponent],
  host: { class: 'shrink-0' },
  template: `
    <div class="flex flex-row items-center gap-4">
      <h1 [id]="headingId" class="text-primary flex-1 text-2xl font-medium" data-test-id="dialog-header-heading">
        {{ heading }}
      </h1>
      @if (showCloseButton) {
        <ods-button
          icon="close"
          variant="ghost"
          size="fit"
          ariaLabel="Dialog schließen"
          data-test-id="dialog-close-button"
          (clicked)="closeClicked.emit()"
        />
      }
    </div>
    <ng-content />
  `,
})
export class DialogHeaderComponent {
  @Input({ required: true }) heading!: string;
  @Input() showCloseButton: boolean = true;

  headingId: string = '';

  @Output() closeClicked = new EventEmitter<void>();
}
